import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import Rating from '@prisjakt/ui-rating';
import RatingHelper from '@prisjakt/ui-rating/src/rating-helper';
import RatingIcon from '../../../rating/rating-icon';

import * as S from './styles';

import { RatingString } from '../../../rating/types';

import { getSmileyRating } from '../../../rating/utils';

type Props = {
  type: 'store' | 'product';
  rating: number;
};

const ReviewRating = ({ type, rating }: Props) => {
  const { t } = useContext(AppContext);

  if (type === 'store') {
    const rate = RatingHelper.convert(rating, 1);
    const smileyRating = getSmileyRating(rate.real);

    return smileyRating?.iconType && smileyRating?.text ? (
      <>
        <RatingIcon type={smileyRating.iconType} disabled={false} />
        <S.Text>{t('reviews', smileyRating.text as RatingString)}</S.Text>
      </>
    ) : null;
  }

  return <Rating rate={rating} />;
};

export default ReviewRating;
